import Environment from "../util/Environment";
import curry from "../util/curry";
import Overlayer from "../util/Overlayer";
import type Ad from "../gpt/Ad";
import type GPT from "../gpt/GPT";
import AdDebug from "./AdDebug";

class AdDebugRegistry {

    private _registeredAds: Ad[] = [];
    private _startTime = Environment.currentTime();
    private _debugOnRenderMode = false;
    private _adMetrics: Record<string, unknown> = {};

    constructor() {
        // @ts-expect-error fix when not in Q4
        window.__bloomberg__.adMetrics = this._adMetrics;
    }

    /**
     * Add an Ad to the registry for debugging
     */
    push(ad: Ad, name: string, gpt: GPT) {
        if (this._debugOnRenderMode) {
            ad.onRender(curry(AdDebug.show, this._startTime, ad, gpt));
            ad.onEmpty(curry(AdDebug.show, this._startTime, ad, gpt));
        }

        this._adMetrics[name] = new Promise((resolve) => {
            const resolveMetrics = () => resolve(AdDebug.metrics(this._startTime, ad));

            ad.onRender(resolveMetrics);
            ad.onEmpty(resolveMetrics);
        });

        this._registeredAds.push(ad);
    }

    /**
     * Displays debug information for all registered ads
     */
    showDebugInformation(gpt: GPT) {
        Overlayer.clearOverlays();

        this._registeredAds.forEach(curry((ad) => AdDebug.show(this._startTime, ad, gpt)));
    }

    /**
     * Displays debug information when Ad has finished rendering
     *

     */
    showDebugInformationOnRender() {
        this._debugOnRenderMode = true;
    }

    /**
     * Clears the list of registered ads
     *

     */
    destroy() {
        // @ts-expect-error fix when not in Q4
        this._adMetrics = null;
        this._registeredAds.length = 0;
    }

}

export default AdDebugRegistry;
